import React from 'react';
import SideNavBar from '../../components/headers/sidenavbar/SideNavBar';
import UserData from '../../components/headers/topnavbar/UserData';
import CreateSessionChild from '../../components/sessionChild/CreateSessionChild';

export default function CreateSession() {
    return (
        <>
            <div id="wrapper">
                <SideNavBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <UserData />
                        <div className="container-fluid">
                            <CreateSessionChild />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
